import { awsToSimpleObject } from "../../../main";
import { PlaceList, PlaceListEntry } from "../../../models";
import { DataProviderArgs } from "../../DataStore/DataProvider";
import { IPlaceListEntryTable } from "../IPlaceListEntryTable";
import { IPlaceListEntry } from "../IPlaceListTable";
import { DataStoreTable } from "./DataStoreTable";

export class PlaceListEntryTable
    extends DataStoreTable<IPlaceListEntry>
    implements IPlaceListEntryTable
{
    constructor(args: DataProviderArgs) {
        super(
            args,
            "place-list-entries",
            PlaceListEntry,
            (obj: any) => awsToSimpleObject(obj),
            (obj: any) => new PlaceList(obj)
        );
    }
}
